import { DATE_FORMATS_LUXON } from '@/src/utils/dateHelpers'
import { TypographyStyles } from '@/styles'
import { Alert, Text, Button } from '@/ui'
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons'
import { useNavigate } from 'react-router-dom'
import type { DateTime } from 'luxon'

export const NeedsReviewAlert = ({
  needsReviewTransactionsCount,
  startDate,
  endDate,
}: {
  needsReviewTransactionsCount: number
  startDate: DateTime | null
  endDate: DateTime | null
}) => {
  const navigate = useNavigate()
  if (!startDate || !endDate) {
    return null
  }
  return (
    <Alert customIconName={faTriangleExclamation} variant="warning">
      <div className="grid grid-cols-1 sm:grid-cols-4 gap-y-4 sm:gap-x-6 items-center">
        <div className="sm:col-span-3">
          <Text variant={TypographyStyles.H3}>Incomplete report</Text>
          <Text variant={TypographyStyles.BODY_SM}>
            We need you to clarify <b>{needsReviewTransactionsCount}</b>{' '}
            transactions to complete your report for this month. Until then,
            your numbers may not be fully accurate.
          </Text>
        </div>
        <div className="sm:col-span-1 flex justify-start sm:justify-end items-center">
          <Button
            onClick={() => {
              navigate(
                `/transactions/review?startDate=${startDate?.toFormat(DATE_FORMATS_LUXON.INPUT)}&endDate=${endDate?.toFormat(DATE_FORMATS_LUXON.INPUT)}`
              )
            }}
          >
            Clarify Now
          </Button>
        </div>
      </div>
    </Alert>
  )
}
